<template>
  <FilterSelectorItem
    :label="filterLabel"
    :options="urgencyFilter.options"
    :variant="variant"
    @option-selected="handleFilterChange"></FilterSelectorItem>
</template>

<script setup lang="ts">
import { storeToRefs } from "pinia";

import useFilterItem from "@/composition/archive/useFilterItem.ts";
import useFilterSelectorStore from "@/stores/search/filterSelector.ts";

import FilterSelectorItem from "./FilterSelectorItem.vue";
import type { FilterSelectorItemWrapperProps } from "./filterSelectorItemWrapper";

defineProps<FilterSelectorItemWrapperProps>();
const filterSelectorStore = useFilterSelectorStore();
const { selectedUrgencies, urgencyFilter } = storeToRefs(filterSelectorStore);

const { handleFilterChange, filterLabel } = useFilterItem(
  urgencyFilter,
  selectedUrgencies,
);
</script>
